<template>
  <div align="Left">
    <md-card id="readers" align="Left">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <i class="material-icons">group</i>
        </div>
        <h4 class="title">Readers</h4>

        <div class="md-layout md-gutter md-layout-item md-size-100 md-alignment-center-left" style="padding: 0;">
          <div class="md-layout md-gutter md-layout-item md-size-20">
            <md-field class="md-sm">
              <label>Search</label>
              <md-input v-model="searchQuery" @keyup.enter="handleSearch" />
            </md-field>
          </div>
          <div class="md-layout md-gutter md-layout-item md-size-20" v-if="organizations.length > 2">
            <md-field class="md-sm">
              <label for="currentType">Organization</label>
              <md-select v-model="currentOrganization" name="organization">
                <md-option v-for="(type, index) in organizations" :key="index" :value="type.value">
                  {{ type.label }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout md-gutter md-layout-item md-size-20">
            <md-button class="md-icon-button md-primary" @click="handleSearch">
              <md-icon>search</md-icon>
            </md-button>
          </div>
          <div class="md-layout md-gutter md-layout-item md-alignment-center-right" :class="[
            { 'md-size-40': organizations.length > 2 },
            { 'md-size-60': organizations.length <= 2 }
          ]">
            <md-button class="md-icon-button md-primary" @click="handleAdd">
              <md-icon>add</md-icon>
              <md-tooltip md-direction="bottom">Add new reader</md-tooltip>
            </md-button>
            <md-button class="md-icon-button" @click="handleRefresh">
              <md-icon>refresh</md-icon>
              <md-tooltip md-direction="bottom">Refresh list</md-tooltip>
            </md-button>
          </div>
        </div>
      </md-card-header>

      <md-card-content style="padding-top: 0px">
        <md-table v-if="!isLoading" :value="filteredReaders" class="table-shopping table-striped table-hover">
          <md-table-row v-if="!isLoading">
            <md-table-empty-state :md-description="`No readers found for this search value`"
              md-label="No readers found">
            </md-table-empty-state>
          </md-table-row>
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="Name">
              {{ (item.firstName || "-") + " " + (item.lastName || "-") }}
            </md-table-cell>

            <md-table-cell md-label="Email">
              {{ item.email || "-" }}
            </md-table-cell>

            <md-table-cell md-label="Phone">{{ item.cellNumber || "-" }}</md-table-cell>
            <md-table-cell md-label="Status">{{ defineStatus(item.status) }}</md-table-cell>
            <md-table-cell md-label="Actions">
              <div style="display: flex">
                <md-button v-if="isAdmin" style="margin-right: 0.5rem" class="md-icon-button md-primary"
                  @click="handleActivate(item)">
                  <md-icon>{{ item.status == 2 ? "close" : "check" }}</md-icon>
                  <md-tooltip md-direction="bottom">
                    {{ item.status == 2 ? "Deactivate" : "Activate" }}
                  </md-tooltip>
                </md-button>

                <md-button class="md-icon-button" @click="handleEdit(item.ID)">
                  <md-icon>edit</md-icon>
                  <md-tooltip md-direction="bottom">Edit reader</md-tooltip>
                </md-button>
                <md-button class="md-icon-button md-danger" style="margin-left: 0.5rem" @click="handleRemove(item.ID)">
                  <md-icon>delete</md-icon>
                  <md-tooltip md-direction="bottom">Remove reader</md-tooltip>
                </md-button>
                <md-button v-if="isSuperAdmin" style="margin-left: 0.5rem" class="md-icon-button md-primary"
                  @click="handleOrgEdit(item)">
                  <md-icon>business</md-icon>
                  <md-tooltip md-direction="bottom">Edit organizations</md-tooltip>
                </md-button>
                <md-button class="md-icon-button" style="margin-left: 0.5rem" @click="handleChangePassword(item)">
                  <md-icon>manage_accounts</md-icon>
                  <md-tooltip md-direction="bottom">Change password</md-tooltip>
                </md-button>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table>

        <hr v-if="!isLoading" />
        <div v-if="!isLoading" style="display: flex; align-items: center">
          <div class="pagination-container" style="flex: 1; justify-content: start; height: 50%">
            <a :disabled="offset === 0" class="page-link" style="color: #999" aria-label="Previous" @click="prevPage">
              <i class="fas fa-angle-double-left" />
            </a>
            <span class="page-link"
              style="background-color: #4caf50; color: white; padding: 5px 10px; border-radius: 16px">{{ currentPage
              }}</span>
            <a class="page-link" aria-label="Next" style="color: #999" @click="nextPage">
              <i class="fas fa-angle-double-right" />
            </a>
          </div>
          <div class="table table-stats" style="display: flex; justify-content: center; align-items: start; flex: 2">
            <div class="text-right">
              <p class="card-category">
                Showing from
                <b><u>{{ startReader }}</u></b>
                to
                <b><u>{{ endReader }}</u></b>. Total of
                <b><u>{{ totalReaders }}</u></b>
                readers.
              </p>
            </div>
          </div>
          <md-field style="flex: 1; margin-top: 1.5rem">
            <label for="pages">Per page</label>
            <md-select v-model="pagination.perPage" name="pages" @change="updateLimit">
              <md-option v-for="item in pagination.perPageOptions" :key="item" :value="item">
                {{ item }}
              </md-option>
            </md-select>
          </md-field>
        </div>
      </md-card-content>
    </md-card>

    <loader :is-visible="isLoading || isLoadingReader" />
    <register-reader v-if="isModalOpen" :reader="selectedReader" :is-edit="isEdit" :is-modal="true"
      @close="handleClose" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import loader from "@/components/GlobeChek/loader.vue"
import RegisterReader from "@/pages/Auth/RegisterReader.vue"
import Swal from "sweetalert2"

export default {
  components: {
    loader,
    RegisterReader
  },
  data() {
    return {
      isAdmin: (sessionStorage.getItem("usertype") == "Super" || sessionStorage.getItem("usertype") === 'Administrator'),
      isSuperAdmin: sessionStorage.getItem("usertype") == "Super",
      isLoadingReader: false,
      defineStatus: (status) => {
        switch (status) {
          case 1:
          case "1":
            return "Pending"
          case 2:
          case "2":
            return "Active"
          case 3:
          case "3":
            return "Inactive"
          default:
            return " - "
        }
      },
      isModalOpen: false,
      isEdit: false,
      selectedReader: null,
      tableData: [],
      searchQuery: "",
      searchedData: [],
      isLoading: false,
      offset: 0,
      limit: 50,
      pagination: {
        perPage: 50,
        perPageOptions: [10, 20, 50, 100, 200]
      },
      currentOrganization: JSON.parse(sessionStorage.getItem("organizations")).length === 1 ? JSON.parse(sessionStorage.getItem("organizations"))[0].orgId : (localStorage.getItem("currentOrgSelectedForFilters") || "all"),
      organizations: [
        { label: 'All', value: 'all' },
        ...JSON.parse(sessionStorage.getItem('organizations')).map(i => {
          return {
            label: i.orgName,
            value: i.orgId
          }
        }),
      ],
    }
  },
  computed: {
    ...mapGetters(["readersList", "totalReaders"]),
    filteredReaders() {
      return this.tableData
    },
    currentPage() {
      return Math.floor(this.offset / this.limit) + 1
    },
    hasMoreData() {
      return this.offset + this.limit < this.totalReaders
    },
    startReader() {
      return this.totalReaders === 0 ? 0 : this.offset + 1
    },
    endReader() {
      return Math.min(this.offset + this.limit, this.totalReaders)
    }
  },
  watch: {
    "pagination.perPage"(newLimit) {
      this.limit = newLimit
      this.offset = 0
      this.fetchReaders({ search: this.searchQuery, orgId: this.currentOrganization })
    }
  },
  mounted() {
    this.isLoading = true
    this.fetchReaders({ orgId: this.currentOrganization })
  },
  methods: {
    ...mapActions(["listReaders", "deleteReader", "listReaderById", "updateUserStatus"]),
    async handleChangePassword(user) {
      this.isLoadingReader = true
      const detailedReader = await this.listReaderById({ readerId: user.ID })
      this.$emit("openChangePasswordModal", { name: `${detailedReader.personal.firstName} ${detailedReader.personal.lastName}`, personId: detailedReader.editInfo.personID })
      this.isLoadingReader = false
    },
    async handleActivate(reader) {
      const payload = {
        userId: reader.ID,
        status: reader.status === 2 ? 3 : 2
      }

      try {
        const res = await this.updateUserStatus({ payload, userType: "reader" })
        if (res) {
          this.fetchReaders({ search: this.searchQuery, orgId: this.currentOrganization })
        }
      } catch (error) {
        console.error(error)
        Swal.fire({
          title: "Error!",
          text: "An error occurred while updating the reader status.",
          icon: "error"
        })
      }
    },
    async fetchReaders({ search = null, orgId = null } = {}) {
      this.isLoading = true
      try {
        const response = await this.listReaders({
          offset: this.offset,
          limit: this.limit,
          search: search,
          orgId: orgId != 'all' ? orgId : null
        })
        this.tableData = response.doctors
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    updateLimit() {
      this.offset = 0
      this.fetchReaders({ search: this.searchQuery, orgId: this.currentOrganization })
    },
    handleSearch() {
      this.offset = 0
      localStorage.setItem('currentOrgSelectedForFilters', this.currentOrganization)
      this.fetchReaders({ search: this.searchQuery, orgId: this.currentOrganization })
    },
    async handleEdit(readerId) {
      try {
        this.isLoadingReader = true
        const detailedReader = await this.listReaderById({ readerId })
        this.isLoadingReader = false
        this.$store.dispatch("setReaderReg", detailedReader)
        this.selectedReader = detailedReader
        this.isModalOpen = true
        this.isEdit = true
      } catch (error) {
        this.isLoadingReader = false
        console.error(error)
      }
    },
    async handleRemove(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to delete this reader?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true
          try {
            await this.deleteReader(id)
            this.fetchReaders({ search: this.searchQuery, orgId: this.currentOrganization })
            Swal.fire("Deleted!", "Reader has been deleted.", "success")
          } catch (error) {
            console.error(error)
            Swal.fire("Error", "An error occurred while deleting the reader", "error")
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    handleClose(changedSomething) {
      this.isModalOpen = false
      this.selectedReader = null
      this.$store.dispatch("clearReaderReg")
      this.isEdit = false
      if (changedSomething) {
        this.fetchReaders({ search: this.searchQuery, orgId: this.currentOrganization })
      }
    },
    handleAdd() {
      this.isModalOpen = true
      this.isEdit = false
    },
    handleRefresh() {
      this.offset = 0
      this.fetchReaders({ search: this.searchQuery, orgId: this.currentOrganization })
    },
    prevPage() {
      if (this.offset > 0) {
        this.offset -= this.limit
        this.fetchReaders({ search: this.searchQuery, orgId: this.currentOrganization })
      }
    },
    nextPage() {
      if (this.hasMoreData) {
        this.offset += this.limit
        this.fetchReaders({ search: this.searchQuery, orgId: this.currentOrganization })
      }
    },
    async handleOrgEdit(reader) {
      try {
        this.isLoadingReader = true
        const detailedReader = await this.listReaderById({ readerId: reader.ID })
        this.isLoadingReader = false
        this.$emit("openOrgEditModal", detailedReader)
      } catch (error) {
        this.isLoadingReader = false
        console.error(error)
        Swal.fire({
          title: "Error!",
          text: "Failed to fetch reader details.",
          confirmButtonText: "OK"
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.md-table {
  max-height: 67dvh;
  overflow: auto;
}

.md-table-cell {
  padding: 2px 8px;
  font-size: 14px;
}

.text-right ::v-deep .md-table-cell-container {
  display: flex;
  justify-content: flex-end;
}

.md-table ::v-deep .md-table-head:last-child {
  text-align: left;
}

.table-shopping {
  table>thead>tr>th {
    text-transform: uppercase;
  }

  table>thead>tr>.md-table-head .md-table-head-label {
    font-size: 0.75rem;

    b {
      display: block;
      margin-bottom: 3px;
    }
  }

  .td-name {
    font-size: 1em !important;
    line-height: 1.1;

    small {
      color: green;
      font-size: 0.77em;
    }
  }

  .td-name {
    min-width: 200px;
  }

  .td-phone {
    text-align: left;
    min-width: 150px;

    small {
      margin-right: 3px;
    }
  }

  .img-container {
    width: 120px;
    max-height: 160px;
    overflow: hidden;
    display: block;

    img {
      width: 100%;
    }
  }
}

.md-table-row:hover {
  background-color: #74b5ff !important;
  color: white;
}

.table-striped {
  tbody>tr:nth-of-type(odd) {
    background-color: #edf2f7;
  }

  tbody>tr:nth-of-type(even) {
    background-color: #ffffff;
  }
}

.mmodal-container {
  max-width: 70vw;
  max-height: 75vh !important;
  overflow: auto;

  margin: 0px auto;
  position: relative;
  background-color: #fff;
  transition: all 0.3s ease;
  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2), 0 40px 77px 0 rgba(0, 0, 0, 0.22);
  border-radius: 6px;
  border: none;
  z-index: 9999;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

.pagination-container span {
  margin: 0 15px;
}
</style>
